var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveKaIconUrl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3522_1920)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.22705 8.05216C8.28855 9.6895 8.35628 11.4604 8.41937 13.1003C8.49361 15.0324 10.0665 16.5459 12 16.5459C13.9336 16.5459 15.5065 15.0324 15.5808 13.1003L15.775 8.05258C13.2945 7.51669 10.7074 7.51659 8.22705 8.05216Z",
    fill: " #45b7bf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.36078 17.1977C9.36546 17.2007 9.3724 17.1679 8.7168 18.9708L9.49492 19.7493C9.54597 19.7986 10.4708 20.6707 12 20.6707C13.5405 20.6707 14.4934 19.7609 14.5027 19.7517L15.2833 18.9707C14.6122 17.1248 14.644 17.1948 14.6393 17.1979C13.0313 18.2031 10.9722 18.2049 9.36078 17.1977Z",
    fill: " #45b7bf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 22.0769C9.8585 22.0769 8.55737 20.8004 8.50305 20.746L7.82837 20.071V24C9.71967 23.9998 12.3926 23.9992 16.1716 23.9988V20.071L15.4971 20.7459C15.4426 20.8004 14.1415 22.0769 12 22.0769Z",
    fill: " #45b7bf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.00008 12.789C6.94725 11.4001 6.83302 8.31894 6.80167 7.58014C6.79403 7.19959 6.98761 6.89843 7.33826 6.81537C10.3912 6.05365 13.6177 6.0544 16.6702 6.81753C16.993 6.89824 17.2145 7.17671 17.2023 7.52661C17.1873 7.91781 17.0014 12.7513 16.9999 12.789C24.3173 10.6859 23.6159 4.90626 15.596 3.3771L15.5959 3.37644C13.2858 2.93556 10.6991 2.938 8.40414 3.37593C8.40076 3.41052 5.31328 3.8416 3.35449 5.51401C0.755603 7.73281 1.54072 11.2199 7.00008 12.789Z",
    fill: " #45b7bf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4534 1.92308C15.3415 0.7808 14.4118 0 13.3523 0H10.6478C9.58818 0 8.65852 0.781221 8.54663 1.92313C10.7825 1.54651 13.2145 1.54599 15.4534 1.92308Z",
    fill: " #45b7bf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9573 21.6814C20.656 20.4428 19.5356 19.5458 18.228 19.5458H17.5779V23.9987C18.5291 23.9987 19.5427 23.9986 20.6246 23.9986C21.0709 23.9986 21.4103 23.5829 21.3097 23.1397C21.2967 23.0828 21.3515 23.3103 20.9573 21.6814Z",
    fill: " #45b7bf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.42215 19.5458H5.77203C4.46556 19.5458 3.34423 20.4417 3.0427 21.6814C2.67044 23.2196 2.67236 23.1771 2.67236 23.2956C2.67236 23.6124 2.89004 23.9013 3.21008 23.9789C3.27983 23.996 2.92444 23.9998 6.42215 24V19.5458Z",
    fill: " #45b7bf"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3522_1920"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveKaIconUrl);
export default __webpack_public_path__ + "static/media/active_KaIcon_url.3f4ade6682732b5fc8e6fe99dfbd1f31.svg";
export { ForwardRef as ReactComponent };